import { useState } from "react";
import { useTranslation } from "react-i18next";
// import PageHeadline from "../../components/shared/PageHeadline";

export default function RaceResult() {
    const [currentIndex, setCurrentIndex] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [isComingSoon, setIsComingSoon] = useState(false);

    const { t } = useTranslation();

    return (
        <div className="text-white md:px-0 px-4 2xl:pb-96 lg:pb-96 md:pb-80 pb-40 bg-rulesRegistrationMobile md:bg-rulesRegistration bg-cover bg-no-repeat">
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("raceResultTitle")} />
            </div> */}
            <div className="relative top-24 md:top-40 2xl:px-0 md:px-14 px-0">
                <div className="basis-full py-8 max-md:max-w-[200px] max-md:text-wrap 2xl:p-16 2xl:pb-0">
                    <span className="font-superWonder text-5xl md:text-8xl text-brandYellow">{t("raceResultTitle")}</span>
                </div>
                {/* <div className="top-80 relative bg-black pb-96"> */}
                <div className="top-12 relative mt-10 2xl:mt-0 font-poppins pb-16">
                    {isComingSoon ? (<h1 className="text-4xl uppercase font-bold italic">Coming Soon</h1>) : (<div className="min-h-screen container mx-auto w-full font-poppins text-white xl:py-8">
                        <div className="flex items-center justify-center flex-row gap-x-10">
                            <button
                                onClick={() => setCurrentIndex(0)}
                                className={`py-2 border-white px-8 text-lg ${currentIndex === 0 ? "font-bold border-b" : ""
                                    }`}
                            >
                                2026
                            </button>
                        </div>
                        <div className="mt-8 2xl:px-0 md:px-14 px-0">
                            <iframe
                                title="Lokasi"
                                src="https://result.race.id/results.aspx?CId=20127&RId=3112"
                                allowfullscreen="true"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                className="w-full h-[90rem] rounded-lg"
                            ></iframe>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>
    );
}
